const { toggleAttribute, toggleClass } = require('../../common')

module.exports = (sltName) => {
  const toggleBtns = document.querySelectorAll(`${sltName}toggle-btn`)

  const toggle = (button, container) => {
    toggleAttribute(button, 'aria-expanded')
    toggleClass(button, 'is-active')
    toggleClass(container, 'js-show')
  }

  const toggleBtn = (event) => {
    event.preventDefault()
    const button = event.currentTarget
    const controls = button.getAttribute('aria-controls')
    const container = document.getElementById(controls)

    toggleActive(button)
    toggle(button, container)
  }

  const toggleActive = (activeButton) => {
    const activeToggleBtns = document.querySelectorAll(
      `${sltName}toggle-btn.is-active`
    )
    activeToggleBtns.forEach((button) => {
      const controls = button.getAttribute('aria-controls')
      const container = document.getElementById(controls)
      if (activeButton.id !== button.id) {
        toggle(button, container)
      }
    })
  }

  const addEvents = () => {
    toggleBtns.forEach((elem) => {
      elem.addEventListener('click', toggleBtn, false)
    })
    document.addEventListener('click', (event) => {
      const clickedElement = event.target
      const activeToggleBtn = document.querySelector(
        '.hse-header-dropdown__toggle-btn--translations.is-active'
      )

      if (
        activeToggleBtn &&
        clickedElement.closest(`${sltName}toggle-btn`) === null
      ) {
        toggleActive(activeToggleBtn)
        const controls = activeToggleBtn.getAttribute('aria-controls')
        const container = document.getElementById(controls)
        toggle(activeToggleBtn, container)
      }
    })
  }
  if (toggleBtns) addEvents()
}
